import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/school-list', title: 'School List',  icon:'content_paste', class: '' },
    { path: '/school-bankaccount', title: 'School Bank Account',  icon:'content_paste', class: '' },
    { path: '/master-bankaccount-edit', title: 'Master Bank Account',  icon:'content_paste', class: '' },
    { path: '/transaction-detail', title: 'Transaction Detail',  icon:'library_books', class: '' },
    { path: '/refund-detail', title: 'Refund Detail',  icon:'library_books', class: '' },
    //{ path: '/user-profile', title: 'User Profile',  icon:'person', class: '' },
    //{ path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
    //{ path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
    //{ path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
    //{ path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
    //{ path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
    //{ path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts